import React, { useState } from 'react';
import { LandingPageTakeover } from '@/components/landing-pages/landing-page-takeover';
import { useActiveLandingPages } from '@/hooks/use-active-landing-pages';
import { useAuthenticatedUserContext } from '@/contexts/user-context';

interface Props {
  // react-native-modal can't stack, so this is set to false when a higher
  // priority overlay is shown
  canShow?: boolean;
}

export const LandingPageWrapper: React.FC<Props> = ({ canShow = true }) => {
  const { selectedRestaurantRelationship } = useAuthenticatedUserContext();
  const [isDismissed, setIsDismissed] = useState(false);

  const { landingPages } = useActiveLandingPages({
    restaurantUUID: selectedRestaurantRelationship.uuid,
    supplierUUID: selectedRestaurantRelationship.supplierUUID,
  });

  if (isDismissed || !canShow || landingPages.length === 0) {
    return null;
  }

  return (
    <LandingPageTakeover
      landingPages={landingPages}
      onDismiss={() => setIsDismissed(true)}
      restaurantUUID={selectedRestaurantRelationship.uuid}
      supplierUUID={selectedRestaurantRelationship.supplierUUID}
    />
  );
};
